<script setup lang="ts">

import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { formatShort } from '@/models/formatNumber.ts'

defineProps({
  type: {
    type: String,
    required: true
  },
  amount: {
    type: Number,
    required: true
  },
  textColor: {
    type: String,
    default: 'text-subtext'
  },
  tooltip: {
    type: String,
    default: ''
  }
})

</script>

<template>
  <div class="flex">
    <GenericIcon :type="type" :tooltip="tooltip"/><span :class="textColor + ' ps-2'">{{ formatShort(amount) }}</span>
  </div>
</template>

<style scoped lang="scss">

</style>